import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from '@bookly/shared';

import { AuthApiResponse } from '../model/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  readonly #http = inject(HttpClient);
  readonly #authUrl = environment.shared.authApi;
  readonly #logoutUrl = environment.shared.logoutApi;

  public redirectToGoogle() {
    const googleOauthUrl = environment.shared.googleAuthUrl;
    const googleParams = {
      redirect_uri: window.location.origin,
      prompt: 'consent',
      response_type: 'code',
      client_id: environment.shared.googleClientId,
      scope:
        'openid email profile https://www.googleapis.com/auth/calendar.events.freebusy https://www.googleapis.com/auth/calendar.freebusy',
      access_type: 'offline',
      service: 'lso',
      o2v: 2,
      theme: 'glif',
      ddm: 0,
      flowName: 'GeneralOAuthFlow',
    };
    const queryParams = new HttpParams({
      fromObject: googleParams,
    });

    window.location.assign(`${googleOauthUrl}?${queryParams.toString()}`);
  }

  public requestToken(requestParams: Params): Observable<AuthApiResponse> {
    const params: Params = {
      ...requestParams,
      redirect_uri: window.location.origin,
    };
    return this.#http.get<AuthApiResponse>(this.#authUrl, {
      params,
    });
  }

  public logout(deviceToken: string | null, refreshToken: string) {
    let params = new HttpParams().set('refreshToken', refreshToken);
    if (deviceToken !== null) {
      params = params.set('deviceToken', deviceToken);
    }
    return this.#http.get(this.#logoutUrl, {
      params: params,
    });
  }

  public refreshToken(refreshToken: string): Observable<AuthApiResponse> {
    const params: Params = { refresh_token: refreshToken };
    return this.#http.get<AuthApiResponse>(this.#authUrl, { params });
  }
}
